import React from "react";
import {
    useJWT,
} from './JWT';
import { RefreshButton } from './RefreshButton';
import {
    useParams
} from "react-router-dom";
import {
    BiLoaderCircle
} from "react-icons/bi";
import Alert from 'react-bootstrap/Alert';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';

export function Logs() {
    const jwt = useJWT();
    const { namespace, handle } = useParams();
    const [error, setError] = React.useState("");
    const [loading, setLoading] = React.useState(true);
    const [logs, setLogs] = React.useState([]);

    async function loadLogs(jwt, namespace, handle) {
        fetch(`https://api.${process.env.REACT_APP_DOMAIN}/rest/bots/${namespace}/${handle}/logs`, {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + jwt.token
            }
        }).then(response => {
            if (!response.ok) {
                throw new Error(`${response.status} ${response.statusText}`);
            }
            return response.json()
        }).then(payload => {
            setLogs(payload.logs);
            setError(false);
            setLoading(false);
        }).catch(error => {
            console.error("loading logs: ", error);
            setLogs([]);
            setError(error);
            setLoading(false);
        })
    }

    React.useEffect(() => {
        loadLogs(jwt, namespace, handle);
    }, [jwt, namespace, handle]);

    if (loading) {
        return (
            <><BiLoaderCircle/></>
        );
    }
    if (error) {
        return (
            <Alert variant="danger">
              {error.message}
            </Alert>
        );
    }
    return (
        <>
          <Alert variant="info">
            Here is the latest stdout and stderr output of <span className="font-weight-bold">{namespace}/{handle}</span>.
          </Alert>

          <ButtonToolbar className="justify-content-end mb-1">
            <RefreshButton onClick={() => loadLogs(jwt, namespace, handle)}/>
          </ButtonToolbar>

          <div>
            <pre>
            {logs}
            </pre>
          </div>
        </>
    );
}

export default Logs;
